module.exports = __webpack_public_path__ + "img/arrow-up.f303d69a.svg";